module.exports = __webpack_public_path__ + "static/img/e6.d33c7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/e6.png
// module id = w2Gj
// module chunks = 1